import {
  ClockCircleOutlined,
  CreditCardOutlined,
  EyeOutlined,
  FundProjectionScreenOutlined,
  PrinterOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ModuleSidebarLayout, {
  type ModuleOutletContext,
} from "../../components/moduleSidebar/ModuleSidebarLayout";

export type ConfigOutletContext = ModuleOutletContext;

const Configuration = () => {
  const { t } = useTranslation();

  // Редът определя и fallback-а „първата разрешена страница"; правата трябва
  // да съвпадат с route-овете в main.tsx. „Схема на заведението" и
  // „Конфигурация на маси" са в модула „Резервации".
  const sections = [
    {
      title: t("configSidebar.sectionMain"),
      pages: [
        {
          path: "/configuration",
          permission: "manage_monitors",
          label: t("configSidebar.monitors"),
          Icon: FundProjectionScreenOutlined,
        },
        {
          path: "/configuration/devices",
          permission: "manage_devices",
          label: t("configSidebar.devices"),
          Icon: PrinterOutlined,
        },
        {
          path: "/configuration/ordering",
          permission: "ordering-settings",
          label: t("configSidebar.ordering"),
          Icon: EyeOutlined,
        },
        {
          // Същото право като „Маркиране" — без отделно право за страницата.
          path: "/configuration/working-hours",
          permission: "ordering-settings",
          label: t("configSidebar.workingHours"),
          Icon: ClockCircleOutlined,
        },
        {
          path: "/configuration/payment-methods",
          permission: "manage_payment_types",
          label: t("configSidebar.paymentMethods"),
          Icon: CreditCardOutlined,
        },
        {
          path: "/configuration/companies",
          permission: "manage_companies",
          label: t("configSidebar.companies"),
          Icon: ShopOutlined,
        },
      ],
    },
  ];

  return (
    <ModuleSidebarLayout
      rootPath="/configuration"
      moduleLabel={t("configSidebar.configurationLabel")}
      sections={sections}
    />
  );
};

export default Configuration;
